export default __webpack_public_path__ + "static/media/yo_6.4911188a.mp3";